// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";

import { Accordion, AccordionDetails, AccordionSummary, CardActionArea, Dialog, DialogActions, DialogContent, DialogTitle, Grid, List, ListItem } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import { useState } from "react";
import MDButton from '../../components/MDButton';
import MDBox from '../../components/MDBox';
import MDTypography from '../../components/MDTypography';
import PercentageBar from '../../components/PercentageBar';

// Images
import phantomNodeImg from '../../assets/images/phantom_node.png';
import spectraFlexImg from '../../assets/images/assetImages/SpectraFlex Adaptive Wear.png';
import morphoGloveImg from '../../assets/images/assetImages/Morpho-Touch Glove.png';
import missionScopeImg from '../../assets/images/assetImages/MissionScope Planner.png';
import swarmImg from '../../assets/images/assetImages/Swarm Intelligence Deployment Suite.png';
import advTactMobileImg from '../../assets/images/assetImages/Advanced Tactical Mobility System.png';
import stingrayImg from '../../assets/images/assetImages/STINGRAY-X — Autonomous Littoral Navigation Beacon (ALNB).png';
import disruptionImg from '../../assets/images/assetImages/Cyber-Physical Disruption Suite (CPDS).png';
import seopImg from '../../assets/images/assetImages/Strategic Effects Orchestration Platform (SEOP).png';
import agsfsImg from '../../assets/images/assetImages/Adaptive Ground Sensing & Fusion System (AGS-FS).png';
import tgtihImg from '../../assets/images/assetImages/Tactical Geospatial & Threat Intelligence Hub (TG-TIH).png';
import iideImg from '../../assets/images/assetImages/Intelligent Information Distribution Engine (IIDE).png';
import sddcmImg from '../../assets/images/assetImages/Secure Device & Data Concealment Module (SDDCM).png';

function AssetCard({ index, title, setParentViewIndex, selectedIndex, virtual }) {

    const imageDictionary = {
        "Phantom Node": phantomNodeImg,
        "SpectraFlex Adaptive Wear": spectraFlexImg,
        "Morpho-Touch Glove": morphoGloveImg,
        "MissionScope Planner": missionScopeImg,
        "Swarm Intelligence Deployment Suite": swarmImg,
        "Advanced Tactical Mobility System": advTactMobileImg,
        "STINGRAY-X — Autonomous Littoral Navigation Beacon (ALNB)": stingrayImg,
        "Cyber-Physical Disruption Suite (CPDS)": disruptionImg,
        "Strategic Effects Orchestration Platform (SEOP)": seopImg,
        "Adaptive Ground Sensing & Fusion System (AGS-FS)": agsfsImg,
        "Tactical Geospatial & Threat Intelligence Hub (TG-TIH)": tgtihImg,
        "Intelligent Information Distribution Engine (IIDE)": iideImg,
        "Secure Device & Data Concealment Module (SDDCM)": sddcmImg
    }

  return (
    <Card sx={{
            backgroundColor: selectedIndex === index ? "navy.focus" : "navy.main",
            border: `2px solid ${virtual ? "#64D5CF" : "#2B5587"}`,
            height: '100%'
        }}>
        <CardActionArea onClick={() => setParentViewIndex(index)}>
                <MDBox position="relative" borderRadius="lg" mt={1} mx={2}>
                    <MDBox
                    component="img"
                    src={imageDictionary[title]}
                    alt={title}
                    borderRadius="lg"
                    shadow="md"
                    width="100%"
                    height="100%"
                    position="relative"
                    zIndex={1}
                    />
                    <MDBox
                    borderRadius="lg"
                    shadow="md"
                    width="100%"
                    height="100%"
                    position="absolute"
                    left={0}
                    top="3%"
                    sx={{
                        backgroundImage: `url(${imageDictionary[title]})`,
                        transform: "scale(0.94)",
                        filter: "blur(12px)",
                        backgroundSize: "cover",
                    }}
                    />
                </MDBox>
                <MDBox p={3}>
                    <MDTypography display="inline" variant="h6" textTransform="capitalize" fontWeight="bold">
                        {title}
                    </MDTypography>
                </MDBox>
        </CardActionArea>
    </Card>
  );
}

// Typechecking props for the SimpleBlogCard
AssetCard.propTypes = {
  title: PropTypes.string.isRequired,
};

export default AssetCard;